import React, { Component } from 'react';
import { Form, Field } from 'react-final-form';
import { OnChange } from 'react-final-form-listeners'
import { Col, Row, Label, Alert } from 'reactstrap';
import PropTypes from 'prop-types';
// import { LinkContainer } from 'react-router-bootstrap';

// Local Deps
import './UserForm.scss';
import msgs from '../../../config/messages';
import formConfig from './formConfig';
import NFButton from '../../primitives/NFButton';
// import { accountAdminRoute, superAdminHomeRoute } from '../../../config/navigation/routes';
// import history from '../../../config/history';

import { required } from '../../../utils/validationUtils';

class UserForm extends Component {
  static propTypes = {
    onSubmit: PropTypes.func.isRequired,
    onChangeRole: PropTypes.func.isRequired,
    onChangeField: PropTypes.func.isRequired,
    initialValues: PropTypes.shape({
      id: PropTypes.string,
      fullName: PropTypes.string,
      email: PropTypes.string,
      phoneNumber: PropTypes.string,
      faxNumber: PropTypes.string,
      iconStatus: PropTypes.string,
      role: PropTypes.string,
    }),
    auth: PropTypes.shape({
      jwtToken: PropTypes.string,
      expiration: PropTypes.number,
      organizationId: PropTypes.string,
      role: PropTypes.string,
    }).isRequired,
    iconStatusIsHidden: PropTypes.bool,
    alertType: PropTypes.string.isRequired,
    alertMessage: PropTypes.string.isRequired,
    onCancelUserForm: PropTypes.func.isRequired,
  };

  static defaultProps = {
    iconStatusIsHidden: false,
    initialValues: {},
  };

  render() {
    const {
      onSubmit,
      onChangeRole,
      onChangeField,
      initialValues,
      iconStatusIsHidden,
      alertMessage,
      alertType,
      onCancelUserForm,
    } = this.props;

    return (
      <div className="nf-tooling-def-form">
        <Form
          onSubmit={onSubmit}
          initialValues={initialValues}
          onChangeRole={onChangeRole}
          onChangeField={onChangeField}
          render={({
            handleSubmit,
            // pristine,
            invalid,
            submitting,
            validating,
          }) => (
            <form className="nf-user-form" onSubmit={handleSubmit}>
              {alertMessage && <Alert color={alertType}>{alertMessage}</Alert>}
              {/* <Alert style={{ height: '50px' }} color="success">
              Something happened
            </Alert> */}
              <div>
                {/* <!-- CONFIGURED FIELDS --> */}

                {formConfig.map((fieldConfig, idx) => (
                  <Field
                    key={idx} {...fieldConfig}
                    disabled={fieldConfig.name === 'email' && initialValues.id}
                  />
                ))}

                {formConfig.map((fieldConfig, idx) => (
                  <OnChange key={idx} name={fieldConfig.name}>
                    {(value) => {
                      onChangeField(value, fieldConfig.name)
                    }}
                  </OnChange>
                ))}

                {/* <!-- SELECT FIELDS --> */}
                {!iconStatusIsHidden && (
                  <Field name="iconStatus" validate={required}>
                    {({ input, meta }) => (
                      <Row className="nf-user-form__label-input-pair">
                        <Col sm={3}>
                          <Label className="nf-user-form__label">
                            {msgs.AddUser.iconStatus}
                            <span className="nf-user-form__required">*</span>
                          </Label>
                        </Col>
                        <Col sm={3}>
                          <select {...input}>
                            <option value="approved">
                              {msgs.AddUser.approved}
                            </option>
                            <option value="blocked">
                              {msgs.AddUser.blocked}
                            </option>
                          </select>
                        </Col>
                        <Col sm={2}>
                          {meta.touched &&
                            meta.error && (
                              <span className="nf-user-form__error">
                                {meta.error}
                              </span>
                            )}
                        </Col>
                      </Row>
                    )}
                  </Field>
                )}

                {this.props.auth.role === 'SUPER_ADMIN' && (
                  <div>
                    <Field name="role">
                      {({ input, meta }) => (
                        <Row className="nf-user-form__label-input-pair">
                          <Col sm={3}>
                            <Label className="nf-user-form__label">
                              Role
                              <span className="nf-user-form__required">*</span>
                            </Label>
                          </Col>
                          <Col sm={3}>
                            <select {...input} >
                              <option value="user" >
                                {msgs.AddUser.accountUser}
                              </option>
                              <option value="admin" >
                                {msgs.AddUser.accountAdmin}
                              </option>
                              <option value="super">
                                {msgs.AddUser.accountSuper}
                              </option>
                            </select>

                          </Col>
                          <Col sm={2}>
                            {meta.touched &&
                              meta.error && (
                                <span className="nf-user-form__error">
                                  {meta.error}
                                </span>
                              )}
                          </Col>
                        </Row>
                      )}
                    </Field>
                    <OnChange name="role">
                      {(value) => {
                        onChangeRole(value)
                      }}
                    </OnChange>
                  </div>

                )}
                {this.props.auth.role !== 'SUPER_ADMIN' && (
                  <div>
                    <Field name="role">
                      {({ input, meta }) => (
                        <Row className="nf-user-form__label-input-pair">
                          <Col sm={3}>
                            <Label className="nf-user-form__label">
                              Role
                              <span className="nf-user-form__required">*</span>
                            </Label>
                          </Col>
                          <Col sm={3}>
                            <select {...input}>
                              <option value="user">
                                {msgs.AddUser.accountUser}
                              </option>
                              <option value="admin">
                                {msgs.AddUser.accountAdmin}
                              </option>
                            </select>
                          </Col>
                          <Col sm={2}>
                            {meta.touched &&
                              meta.error && (
                                <span className="nf-user-form__error">
                                  {meta.error}
                                </span>
                              )}
                          </Col>
                        </Row>
                      )}
                    </Field>
                    <OnChange name="role">
                      {(value) => {
                        onChangeRole(value)
                      }}
                    </OnChange>
                  </div>
                )}
                <Row>
                  <Col sm={{ size: 7, offset: 2 }} className="text-center">
                    {/* {this.props.auth.role === 'SUPER_ADMIN' && (
                    <LinkContainer to={superAdminHomeRoute.replace(':page', 'searchUsers')}>
                      <NFButton className="nf-button--gray-border">
                        To SuperAdmin
                      </NFButton>
                    </LinkContainer>
                  )} */}
                    {/* <LinkContainer to={accountAdminRoute}>
                    <NFButton className="nf-button--gray-border">
                      {msgs.Form.cancelButton}
                    </NFButton>
                  </LinkContainer> */}
                    <NFButton
                      className="nf-button--gray-border"
                      onClick={() => {
                        onCancelUserForm();
                      }}
                    >
                      {msgs.Form.cancelButton}
                    </NFButton>
                    <NFButton
                      className="nf-button--form nf-button--orange"
                      type="submit"
                      disabled={invalid || submitting || validating}
                    >
                      {msgs.Form.submitButton}
                    </NFButton>
                  </Col>
                </Row>
              </div>
            </form>
          )}
        />
      </div >
    );
  }
}

export default UserForm;



// WEBPACK FOOTER //
// ./src/components/forms/UserForm/UserForm.jsx